import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { mileageRatePresetRepository } from '../data-access/repositories/MileageRatePresetRepository'

const base = ['expense-mileage-configuration']

export const expenseMileageConfigurationQueryConfig = {
  get: () => ({
    queryKey: buildQueryKey([...base]),
    queryFn: () => mileageRatePresetRepository.getExpenseMileageConfiguration(),
  }),
}
